import React, { useState } from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const StateTextInput = ({
  name,
  value,
  onChange,
  label = undefined,
  error = "",
  type = "text",
  className = "",
  placeholder = "",
  variant = "standard",
  size = "medium",
  onKeyDown = undefined,
  multiline = false,
  rows = undefined,
  maxRows = undefined,
  minRows = undefined,
  maxLength = undefined,
  maxChars = undefined, // New prop
  helperText = undefined,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const newValue = e.target.value;
    // If maxChars is set, limit the input length
    if (maxChars && newValue.length > maxChars) {
      return;
    }
    onChange(newValue);
  };

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const getInputType = () => {
    if (type === "password") {
      return showPassword ? "text" : "password";
    }
    return type;
  };

  // Get the effective max length (prioritize maxChars over maxLength)
  const effectiveMaxLength = maxChars || maxLength;

  // Calculate character count for display
  const currentLength = value.length;
  const showCharCount = maxChars !== undefined;

  return (
    <FormControl className={className} variant="standard" error={!!error}>
      <TextField
        name={name}
        type={getInputType()}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        value={value}
        variant={variant}
        size={size}
        label={label}
        error={!!error}
        placeholder={placeholder}
        multiline={multiline}
        rows={rows}
        maxRows={maxRows}
        minRows={minRows}
        inputProps={{
          maxLength: effectiveMaxLength,
        }}
        InputProps={{
          endAdornment: type === "password" && (
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          ),
        }}
        sx={{
          "& .MuiInput-underline:after": {
            borderBottomColor: "#8D58FF",
          },
          "& .MuiInputBase-input": {
            color: "var(--text-primary)",
          },
          "& .MuiInput-underline:before": {
            borderBottomColor: "var(--border-cream)",
          },
          "& .MuiInputLabel-root": {
            color: "var(--text-secondary)",
          },
        }}
        InputLabelProps={{
          sx: {
            "&.Mui-focused": {
              color: "#8D58FF",
            },
            zIndex: 0,
          },
        }}
      />
      <FormHelperText>
        {error || helperText}
        {showCharCount && (
          <span
            style={{
              float: "right",
              color: currentLength > maxChars * 0.9 ? "#f44336" : "inherit",
              fontSize: "0.75rem",
            }}
          >
            {currentLength}/{maxChars}
          </span>
        )}
      </FormHelperText>
    </FormControl>
  );
};

export default StateTextInput;
